import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { getLanguageFromPathname, getAlternatePath } from './routes';
import { translations, getTranslation } from './translations';

const LanguageContext = createContext({
  lang: 'da',
  t: (key) => key,
  getAlternatePath: (targetLang) => '/'
});

export function LanguageProvider({ children }) {
  const { pathname } = useLocation();
  const lang = getLanguageFromPathname(pathname);

  const t = (key) => {
    return getTranslation(lang, key);
  };

  const alternatePath = (targetLang) => {
    return getAlternatePath(pathname, targetLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, getAlternatePath: alternatePath, translations: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export default LanguageContext;
